<template lang="pug">
.card.market-card(v-if="source['ou'] != null || source['oe'] != null")
  .card-header.bg-more-head.collapse-more(
    :id="'heading-ouoe-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-ouoe-' + childId"
    :aria-controls="'collapse-ouoe-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-ouoe-' + childId"
    :id="'collapse-ouoe-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .normal(v-if="source['ou'] || source['oe']")
          .normal-title {{ $t("ui.full_time") }} 
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Odd") }}
              template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][5] != 0 && source['oe'][0][5] != ''")
                OddsItem(:odds="source['oe'][0]" idx=5 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Even") }}
              template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][7] != 0 && source['oe'][0][7] != ''")
                OddsItem(:odds="source['oe'][0]" idx=7 :typ="oddsType" dataType="2")
              template(v-else)
                OddsDisabled
          .normal-odd-area
            .normal-odd-area-oddtype
              p.mb-0 {{ $t("m.ODD_Over") }}
              p.mb-0 {{ $t("m.ODD_Under") }}
            swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
              template(v-for="(dn, i) in source['tn']")
                swiper-slide.normal-odd-area-group
                  template(v-if="source['ou'] && source['ou'][i] && source['ou'][i][11] != 0 && source['ou'][i][12] != 0 && source['ou'][i][11] != '' && source['ou'][i][12] != ''")
                    OddsItem(:odds="source['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" homeAway="1" :details="source" :style="source['tn'] > 4 ? 'width:90px;' : 'width:auto;'") 
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['ou'] && source['ou'][i] && source['ou'][i][11] != 0 && source['ou'][i][12] != 0 && source['ou'][i][11] != '' && source['ou'][i][12] != ''")
                    OddsItem(:odds="source['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="i" homeAway="2" :details="source" :style="source['tn'] > 4 ? 'width:90px;' : 'width:auto;'")
                  template(v-else)
                    OddsDisabled
              swiper-pagination(v-if="source['tn'] > 4" slot="pagination")


        //- .two-column
        //-   .two-column-title {{ $t("ui.full_time") }}
        //-   .two-column-content
        //-     .two-column-group
        //-       .two-column-odd-area
        //-         .two-column-odd-area-oddtype
        //-           p.mb-0 {{ $t("m.ODD_Over") }}
        //-           p.mb-0 {{ $t("m.ODD_Under") }}
        //-         .two-column-odd-area-group
        //-           template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
        //-             OddsItem(:odds="source['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count="0" :details="source" homeAway="1")
        //-           template(v-else)
        //-             OddsDisabled
        //-           template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
        //-             OddsItem(:odds="source['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count="0" :details="source" homeAway="2")
        //-           template(v-else)
        //-             OddsDisabled
        //-     .two-column-group
        //-       .two-column-odd-area
        //-         .two-column-odd-area-oddtype
        //-           p.mb-0 {{ $t("m.ODD_Odd") }}
        //-           p.mb-0 {{ $t("m.ODD_Even") }}
        //-         .two-column-odd-area-group
        //-           template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][5] != 0 && source['oe'][0][5] != ''")
        //-             OddsItem(:odds="source['oe'][0]" idx=5 :typ="oddsType" dataType="2")
        //-           template(v-else)
        //-             OddsDisabled
        //-           template(v-if="source['oe'] && source['oe'][0] && source['oe'][0][7] != 0 && source['oe'][0][7] != ''")
        //-             OddsItem(:odds="source['oe'][0]" idx=7 :typ="oddsType" dataType="2")
        //-           template(v-else)
        //-             OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    },
    childId: {
      type: Number
    }
  },
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true,
        observeParents: true
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    },
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        if (result.length - 2 != 0) {
          if (result.length <= 5) {
            return result[result.length - 2] + " - " + result[result.length - 1];
          }
          if (result.length <= 6) {
            return result[result.length - 3] + " - " + result[result.length - 2] + " - " + result[result.length - 1];
          }
        }
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    },
  }
}
</script>